import { NavLink } from 'react-router-dom';
import { Breadcrumbs as MuiBreadcrumbs, Typography, useTheme } from '@mui/material';

export interface Breadcrumb {
  label: string;
  url?: string;
}

export interface BreadcrumbsProps {
  breadcrumbs: Breadcrumb[];
  fontWeight?: number;
}

export function Breadcrumbs({ breadcrumbs, fontWeight = 600 }: BreadcrumbsProps) {
  const theme = useTheme();

  return (
    <MuiBreadcrumbs>
      {breadcrumbs.map(breadcrumb =>
        breadcrumb.url ? (
          <NavLink
            key={breadcrumb.label}
            to={breadcrumb.url}
            style={{ color: theme.palette.warning.contrastText, textDecoration: 'none' }}
          >
            <Typography variant="h6" fontWeight={fontWeight}>
              {breadcrumb.label}
            </Typography>
          </NavLink>
        ) : (
          <Typography
            variant="h6"
            fontWeight={fontWeight}
            color="text.primary"
            key={breadcrumb.label}
          >
            {breadcrumb.label}
          </Typography>
        )
      )}
    </MuiBreadcrumbs>
  );
}

export default Breadcrumbs;
